<template>
  <Modal
    :title="$t('edit_expense_head')"
    modalId="edit-modal"
    @submit="updateSubCategory"
  >
    <form @submit.prevent="updateSubCategory">

      <!-- Category Select -->
      <div class="mb-3">
          <label class="form-label">{{ $t('select_category') }} <span class="">*</span></label>
            <VueSelect2
            :modelValue="String(sub_category.p_id)"
            :options="formattedCategories"
            :placeholder="$t('select_a_category')"
            class="form-control"
            style="width: 100%;"
            :settings="{
              dropdownParent: '#edit-modal',
              allowClear: true,
            }"
            v-model="sub_category.p_id"
          />
          <div v-if="errors.category_id" class="text-danger mt-2">
            <span>{{ errors.category_id }}</span>
          </div>
      </div>

      <!-- Sub Category Name -->
      <div class="mb-3">
        <label class="form-label">{{ $t('expense_head_name') }} <span class="">*</span></label>
        <input
          type="text"
          v-model="sub_category.node"
          class="form-control"
        />
        <!-- Error for category node -->
        <div v-if="errors.node" class="text-danger mt-2">
          <span>{{ errors.node }}</span>
        </div>
      </div>
      <!-- General error message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import VueSelect2 from 'vue3-select2-component';
import apiUrls from '@/urls';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
    VueSelect2,
  },
  props: {
    selectedSubCategory: {
      type: Object,
      default: () => ({}),
    },
    categories: Array,
  },
  data() {
    return {
      sub_category: {
        id: null,
        node: '',
        p_id: null,
      },
      errorMessage: '',
      errors: {},
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  computed: {
    formattedCategories() {
      return this.categories.map(category => ({
        id: category.account_id,
        text: category.node
      }));
    }
  },
  watch: {
    selectedSubCategory: {
      immediate: true,
      handler(newSubCategory) {
        if (newSubCategory && newSubCategory.id) {
          this.sub_category = { ...newSubCategory };
        }
      },
    },
  },
  methods: {

    async updateSubCategory() {
      try {
        const response = await this.$axios.patch(
          apiUrls.expense_sub_head.update.replace(':pk', this.sub_category.id),
          {
            node: this.sub_category.node,
            p_id: this.sub_category.p_id
          }
        );

        this.toast.success('Expense head successfully updated!')

        // Close modal after success
        const modal = document.getElementById('edit-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update parent component
        this.$emit('edit_success');

        this.resetForm();
      } catch (error) {
        if (error.response) {
          if (error.response.data) {
            // Check if 'node' field is in errors and assign full error message
            if (error.response.data.node && error.response.data.node.length > 0) {
              // Assign the full error message from the array
              this.errors.node = error.response.data.node[0];
            }

            // Handle general error message from backend
            if (error.response.data.error) {
              this.errorMessage = error.response.data.error;
            }
          }
        }
      }
    },

    resetForm() {
      this.sub_category = { id: null, node: '' };
      this.errors = {};
      this.errorMessage = '';
    },
  },

};
</script>
